/* External dependencies */
import { Container, Col, Div, Text, Row } from 'atomize';
import React from 'react';
import { Trans } from 'react-i18next';

interface MeducationTitleProps {
  textSizeXS?: string;
  textSizeMD?: string;
  title: string;
  textColor?: string;
}

export default function MeducationTitle({
  textSizeXS = '32px',
  textSizeMD = '64px',
  title,
  textColor = 'bg_black',
}: MeducationTitleProps) {
  return (
    <Text
      d="inline"
      tag="h3"
      textSize={{
        xs: textSizeXS,
        md: textSizeMD,
      }}
      textColor={textColor}
      textWeight="900"
      style={{ lineHeight: '104%' }}
    >
      <Trans>{title}</Trans>
    </Text>
  );
}
